{% block sw_dashboard_index_content_info_grid %}
    <sw-payments-dashboard-promotion-card />
    <sw-dashboard-statistics-promotion-card />
    {% parent %}
{% endblock %}
